import { JobPostRequirementOperator, JobPostRequirementType } from "./enums";

export const allowedOperatorsByRequirementType: Record<
  JobPostRequirementType,
  JobPostRequirementOperator[]
> = {
  [JobPostRequirementType.StateLicense]: [
    JobPostRequirementOperator.HasAny,
    JobPostRequirementOperator.HasAll,
  ],
  [JobPostRequirementType.ProfessionalType]: [
    JobPostRequirementOperator.HasAny,
  ],
  [JobPostRequirementType.Specialty]: [
    JobPostRequirementOperator.HasAny,
    JobPostRequirementOperator.HasAll,
  ],
  [JobPostRequirementType.FreeText]: [JobPostRequirementOperator.Matches],
};

/**
 * Longest caller-supplied label accepted for professional-type and specialty
 * requirements. Other requirement types derive their label from their value.
 */
export const JOB_POST_REQUIREMENT_DISPLAY_LABEL_MAX_LENGTH = 200;
